import instance from "..";

export const viewProfileApi = () =>
  instance.get(`/api/backend/v1/user/profile/view`);

export const editProfileApi = (data) =>
  instance.put(`/api/backend/v1/user/profile/update`, data);
